import logo from './logo.svg';
import './App.css';
import * as firebase from 'firebase';
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import { store, persistor } from './redux/store';
import { RootRouter } from './router';
import config from './config';
import { useEffect, useState } from 'react';
import AppContext from './utils/appContext';
import ReactGA from 'react-ga';
import { initAnalytics } from './utils/analytics';

if (firebase.apps.length === 0) {
  firebase.initializeApp(config.FIREBASE);
}
function App() {
  initAnalytics('G-LV3D1VN08L', { debug: false });
  const [androidMediaList, setAndroidMediaList] = useState([]);
  const sendUriListToWeb = (list) => {
    setAndroidMediaList(list);
  }
  const mediaContext = {
    androidMediaList,
    setAndroidMediaList,
    sendUriListToWeb,
  };

  return (
    <AppContext.Provider value={mediaContext}> 
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <RootRouter />
        </PersistGate>
      </Provider>
    </AppContext.Provider>
  );
}

export default App;
